"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const __1 = require("..");
/**
 * Initializes refund order, sets refundOf to completed order order id
 * @param event of type InitiateOrderEvent
 * @param prevState
 */
function default_1(event, prevState) {
    var _a, _b;
    const clonedPreviousState = (0, __1.clone)(prevState);
    clonedPreviousState.payments = [];
    const orderItemsArr = (clonedPreviousState === null || clonedPreviousState === void 0 ? void 0 : clonedPreviousState.orderItems) || [];
    const orderItems = orderItemsArr.filter(item => item.status === domain_1.OrderItemStatus.COMPLETED);
    const order = {
        ...clonedPreviousState,
        orderItems: orderItems.map(item => {
            item.status = domain_1.OrderItemStatus.CREATED;
            return item;
        }),
        payments: [],
        createdAt: event.timestamp,
        createdBy: { id: event.triggeredBy },
        createdByDevice: { id: event.deviceId },
        id: event.orderId,
        status: domain_1.OrderStatus.CREATED,
        refundOf: event.refundOf,
        reason: event.reason,
        orderNumber: event.refundOrderNumber,
        ...(0, __1.computeOrderTotals)(clonedPreviousState),
    };
    order.orderType =
        ((_a = prevState === null || prevState === void 0 ? void 0 : prevState.orderType) === null || _a === void 0 ? void 0 : _a.id) && { id: (_b = prevState === null || prevState === void 0 ? void 0 : prevState.orderType) === null || _b === void 0 ? void 0 : _b.id };
    order.source = prevState.source && prevState.source;
    const tables = (0, __1.getTablesFromOrder)(order);
    const updatedTables = tables
        .filter(table => table.id || table.name)
        .map(table => ({
        id: table.id,
        name: table.name,
        ...(table.section && { section: table.section }),
    }));
    order.tables = updatedTables;
    order.table = updatedTables[0];
    return order;
}
exports.default = default_1;
//# sourceMappingURL=initiateRefund.js.map